/* Nutrition A2Z — Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile Menu ──────────────────────────────────────────
  const menuBtn = document.getElementById('mobile-menu-btn');
  const mobileNav = document.getElementById('mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  // ── FAQ Accordion ────────────────────────────────────────
  document.querySelectorAll('.faq-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── Product Tabs ─────────────────────────────────────────
  document.querySelectorAll('.tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = btn.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.tab-content').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
      const content = document.getElementById('tab-' + target);
      if (content) content.classList.add('active');
    });
  });

  // ── Community Poll ───────────────────────────────────────
  const pollCards = document.querySelectorAll('.poll-card');
  const pollSubmitBtn = document.getElementById('poll-submit-btn');
  const pollMessage = document.getElementById('poll-message');
  let selectedCause = null;

  // Load votes from localStorage
  const storageKey = 'na2z_poll_votes';
  let votes = JSON.parse(localStorage.getItem(storageKey) || '{}');
  const defaultVotes = { 'africa': 42, 'south-asia': 28, 'latin-america': 18, 'caribbean': 35, 'mena': 22, 'uk': 31 };
  Object.keys(defaultVotes).forEach(function (k) { if (!votes[k]) votes[k] = defaultVotes[k]; });

  function updateBars() {
    const total = Object.values(votes).reduce(function (a, b) { return a + b; }, 0);
    pollCards.forEach(function (card) {
      const key = card.dataset.cause;
      const bar = card.querySelector('.poll-bar');
      const pct = card.querySelector('.poll-pct');
      if (bar && pct && key) {
        const percent = total > 0 ? Math.round((votes[key] / total) * 100) : 0;
        bar.style.width = percent + '%';
        pct.textContent = percent + '% of votes';
      }
    });
  }

  const hasVoted = localStorage.getItem('na2z_has_voted');
  if (hasVoted) {
    updateBars();
    if (pollSubmitBtn) { pollSubmitBtn.disabled = true; pollSubmitBtn.textContent = 'Thank you for voting!'; }
  }

  pollCards.forEach(function (card) {
    card.addEventListener('click', function () {
      if (hasVoted) return;
      pollCards.forEach(function (c) { c.classList.remove('selected'); });
      card.classList.add('selected');
      selectedCause = card.dataset.cause;
    });
  });

  if (pollSubmitBtn) {
    pollSubmitBtn.addEventListener('click', function () {
      if (!selectedCause) {
        if (pollMessage) { pollMessage.textContent = 'Please select a cause first.'; pollMessage.style.color = '#fbbf24'; }
        return;
      }
      if (localStorage.getItem('na2z_has_voted')) return;
      votes[selectedCause] = (votes[selectedCause] || 0) + 1;
      localStorage.setItem(storageKey, JSON.stringify(votes));
      localStorage.setItem('na2z_has_voted', '1');
      updateBars();
      pollSubmitBtn.disabled = true;
      pollSubmitBtn.textContent = 'Thank you for voting!';
      if (pollMessage) { pollMessage.textContent = 'Your vote has been counted. Thank you for making a difference!'; pollMessage.style.color = '#4ade80'; }
    });
  }

  updateBars();

  // ── Scroll reveal ────────────────────────────────────────
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.product-card, .cause-card, .poll-card, .value-card').forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity .5s ease, transform .5s ease';
      observer.observe(el);
    });
  }

});
